// angular
import {
    Component, OnInit, ViewChild, Input, Output, Injector, EventEmitter, Inject
} from '@angular/core';
import { NgForm } from '@angular/forms';

// shared
import { Configuration } from '../../configurations/shared.config';

// pipes 
import { LocalizePipe } from '../../pipes/Localize.pipe';

// modale
import { Sensor, MainSensorType } from '../../dataModels/sensors-tab-form';
import { LookUpTableName, LookUp } from '../../dataModels/data-models';
import { FilterCriteria, Operator, RelationalLogicalOperator, FilterSearchCriteria, Filtration } from '../../dataModels/grid-list';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';

// service
import { SensorTabService } from '../../services/sensors-tab-form.service';
import { PoliciesTabService } from '../../services/policies-tab-form.service';
import { AuthenticationService } from '../../services/authentication.service';
import { LookupService } from '../../services/lookup.service';

// component
import { ListView, SearchList, SortList } from '../listView/index';
import { MessageDialog } from '../messageDialog/message-dialog.component';
import { SearchFilterComponent } from 'app/operations/subModules/allocationSharedModule/shared/searchFilter/search-filter.component';
import { IErrorHandler, IErrorHandlerToken } from '../../../shared/dataModels/contracts/IErrorHandler';

@Component({
    moduleId: module.id,
    selector: 'sensor-tab-form',
    templateUrl: 'sensors-tab-form.component.html'
})
export class SensorTabComponent extends DiagnosedItem implements OnInit {
    @ViewChild("listView") listView: ListView;
    @Input("trackedObjectId") trackedObjectId: number;
    @Input("SubscriberId") SubscriberId: number;
    @Input("editMode") editMode: boolean = false;
    @ViewChild("sensorForm") form: NgForm;
    @ViewChild("deletemessage") messageDialog: MessageDialog;

    model: Sensor = new Sensor();

    public sensorList: any = {};
    public sensorListCollection: Sensor[] = [];
    // public apiUrl: string = Configuration.urls.webApiEndpoint + Configuration.urls.filterSensorUrl;
    public apiUrl: string = Configuration.urls.webApiEndpoint + Configuration.urls.GetSensorLocal;

    public typeList: any[];
    public providerList: any[];
    public modelList: any[];
    public transporterList: any[];
    public hasError: boolean = false;
    public errorMessage: string;
    public submitted: boolean = false;
    public sensorTypeList: any[] = [];
    public FiltersensorTypeList: LookUp[] = [];
    public MainsensorTypeList: LookUp[] = [];
    public digitalValueList: LookUp[] = [];
    public digitalValueNameList: LookUp[] = [];
    public sensorUnitList: LookUp[] = [];
    public filterCriteria: FilterCriteria = new FilterCriteria();
    public showDigital: boolean = false;
    public isSelectAll: boolean = false;
    public selectedSensor: number = 0;
    public disableDeletedSelected: boolean = true;
    public deleteMessage: string;
    public PortsList: any[] = [];
    public MainSensorType: any[] = ['', 'analog', 'digital', '1 wire data'];
    public EquationMax: boolean = false;
    sensorNameUnique: boolean = true;
    usedPortNumber: boolean = false;
    customTypeUnique: boolean = true;
    allSensorList: any[] = [];
    //ibuttonRFIdUnique: boolean = true;
    @Output() deviceConfigurationData = new EventEmitter();
    constructor(private sensorService: SensorTabService, @Inject(IErrorHandlerToken) private _errorHandler: IErrorHandler, private policiesTabService: PoliciesTabService, private lookupSrv: LookupService, private _localizer: LocalizePipe,
        private authenticationService: AuthenticationService, protected __inj: Injector) {
        super(__inj);
    }

    ngOnInit() {
        // check list of sensors here

        this.filterCriteria.PageSize = 5;
        this.filterCriteria.SearchCriteria = [];
        this.trackedObjectId = this.trackedObjectId != null || this.trackedObjectId == undefined ? this.trackedObjectId : 0;
        this.trackedObjectId != undefined ? this.filterCriteria.SearchCriteria.push({ Operator: Operator.Equal, SearchKey: this.trackedObjectId.toString(), Field: "TrackedObjectId", RelationOperator: RelationalLogicalOperator.And }) : "";
        this.filterCriteria.SearchCriteria.push({ Operator: Operator.NotEqual, SearchKey: 0 + "", Field: "PortNumber", RelationOperator: RelationalLogicalOperator.And });

        this.authenticationService.validUser();
        //if (this.trackedObjectId != undefined) {
        // console.log("from sensors")
        // console.log("this.trackedObjectId", this.trackedObjectId)
        this.getSensorDeviceConfiguration(this.trackedObjectId);
        //}
        this.lookupSrv
            .getCoreLookup(LookUpTableName.SensorType, true)
            .then(result => this.sensorTypeList = result);

        this.lookupSrv
            .getCoreLookup(LookUpTableName.DigitalValue)
            .then(result => this.digitalValueList = result);

        this.lookupSrv
            .getCoreLookup(LookUpTableName.DigitalValueName)
            .then(result => this.digitalValueNameList = result);

        this.lookupSrv
            .getCoreLookup(LookUpTableName.MainSensorType)
            .then(result => this.MainsensorTypeList = result.filter(s => s.Id != 4));

        this.lookupSrv
            .getCoreLookup(LookUpTableName.Unit)
            .then(result => this.sensorUnitList = result);
        let sensorFilter = new FilterCriteria();
        sensorFilter.PageNumber = -1
        sensorFilter.PageCriteria = { PageNumber: -1, PageSize: 10 }

        this.sensorService.getSensorData(sensorFilter).subscribe(res => {
            this.allSensorList = res.Value.Collection;
        });
        // save 
        this.registerSubscription(this.sensorService.saveSensorEvent.subscribe(result => {
            if (!result.IsErrorState) {

                if (this.filterCriteria.SearchCriteria != null && this.filterCriteria.SearchCriteria.filter(o => o.Field == "TrackedObjectId").length > 0)
                    this.filterCriteria.SearchCriteria.find(o => o.Field == "TrackedObjectId").SearchKey = this.trackedObjectId.toString();
                //this.sensorList.Collection.push(this.model);
                this.allSensorList.push(this.model);
                this.listView.Refresh(true);
                this.submitted = false;
                //  this.model = new Sensor();
                this.clearSensor(this.model.ShowCanBus, this.model.WireNumber, this.model.AnalogNumber, this.model.DigitNumber);
                this.lookupSrv
                    .getCoreLookup(LookUpTableName.SensorType)
                    .then(result => {
                        this.sensorTypeList = result;

                    });

            } else if (result.IsErrorState) {
                this.makeDropDownSelected();
                if (
                    // result.ErrorDescription == SensorSettings.Configuartion.messages.sensorPlateExist
                    //  || result.ErrorDescription == SensorSettings.Configuartion.messages.PortTypeCustomDuplicate

                    result.ErrorDescription == Configuration.messages.sensorPlateExist
                    || result.ErrorDescription == Configuration.messages.PortTypeCustomDuplicate
                ) {
                    this.hasError = true;
                    this.errorMessage = result.ErrorDescription;
                }
            }
        }));

        this.messageDialog.confirmClicked.subscribe(x => {
            let selected = this.sensorList.Collection.filter(o => o.isSelected).map(x => x.Id);
            this.allSensorList = this.allSensorList.filter(x => !selected.includes(x.Id));
            this.sensorList.Collection.filter(o => o.isSelected).forEach(c => { c.LastUpdatedBy = this.authenticationService.staffId; });
            this.sensorService.deleteSelected(this.sensorList.Collection.filter(o => o.isSelected).map(({ Id }) => Id));
            this.sensorService.deleteSelectedEvent.subscribe(result => {
                if (result) {

                    this.listView.Refresh(true);
                }
            });

        });


        this.registerSubscription(this.listView.collectionChange.subscribe(result => {

            this.selectedSensor = 0;
            this.disableDeletedSelected = this.selectedSensor == 0;
            this.isSelectAll = false;
        }));
    }
    ShowEquation(event) {
        var Val = event.target.checked;
        this.model.ShowEquationValue = Val;
        if (Val == false) {
            this.model.X4Value = this.model.X3Value = this.model.X2Value = this.model.X1Value = this.model.ConstantValue = "0";
        }

    }
    validate() {
        var sensorType = this.sensorTypeList.find(o => o.Id == this.model.SensorTypeId);
        let IsValid = true;
        this.sensorNameUnique = true;
        this.usedPortNumber = false;
        this.customTypeUnique = true;
        //this.ibuttonRFIdUnique = true;
        // console.log("sensorType", sensorType);

        if (sensorType.ExtraFields.MainSensorTypeId == MainSensorType.analog && this.model.SensorUnitId <= -1)
            IsValid = false;
        if (this.model.PortNumber <= -1)
            IsValid = false;
        if (!this.showDigital && this.model.SensorUnitId < 1)
            IsValid = false;
        if (this.model.ShowEquationValue) {
            if ((this.model.X4Value == "0" || this.model.X4Value == "") &&
                (this.model.X3Value == "0" || this.model.X3Value == "") &&
                (this.model.X2Value == "0" || this.model.X2Value == "") &&
                (this.model.X1Value == "0" || this.model.X1Value == "") &&
                (this.model.ConstantValue == "0" || this.model.ConstantValue == ""))
                IsValid = false;
        }

        if (this.sensorList.Collection.some(x => x.SensorName == this.model.SensorName)) {
            this.sensorNameUnique = false;
            IsValid = false;
        }

        if (this.sensorList.Collection.some(x => x.PortNumber == this.model.PortNumber && x.MainSensorTypeId == this.model.MainsensorTypeId)) {
            IsValid = false;
            this.usedPortNumber = true;
        }

        if (this.model.IsCustom && this.sensorTypeList.some(x => x.DisplayName == this.model.CustomName
            && (x.SubscriberId == this.sensorList.Collection[0].SubscriberId || x.SubscriberId == null) && x.MainSensorTypeId == this.model.MainsensorTypeId)) {
            IsValid = false;
            this.customTypeUnique = false;
        }
        /// if IButton or RFId
        if (this.model.SensorTypeId == 8 || this.model.SensorTypeId == 9) {
            if (this.allSensorList.some(x => x.SensorName == this.model.SensorName)) {
                IsValid = false;
                this.sensorNameUnique = false;
            }

        }
        return IsValid;
    }

    onSave() {
        this.hasError = false;
        this.submitted = true;
        this.EquationMax = false;
        if (this.form.valid && this.validate()) {
            this.model.TrackedObjectId = this.trackedObjectId;
            this.model.CreatedBy = parseInt(this.authenticationService.staffId);
            this.makeNullForSelect();
            this.model.X4Value = this.model.X4Value == "" ? "0" : this.model.X4Value;
            this.model.X3Value = this.model.X3Value == "" ? "0" : this.model.X3Value;
            this.model.X2Value = this.model.X2Value == "" ? "0" : this.model.X2Value;
            this.model.X1Value = this.model.X1Value == "" ? "0" : this.model.X1Value;

            this.model.ConstantValue = this.model.ConstantValue == "" ? "0" : this.model.ConstantValue;
            if (this.model.X4Value == "0" && this.model.X3Value == "0" && this.model.X2Value == "0" && this.model.X1Value == "0" && this.model.ConstantValue == "0")
                this.model.X1Value = "1";
            if (this.model.DigitalValueId == -1)
                this.model.DigitalValueId = null;
            if (this.model.DigitalValueNameId == -1)
                this.model.DigitalValueNameId = null;
            this.model.SubscriberId = this.SubscriberId;
            this.sensorService.save(this.model);
            // emit her the event of update policies
            // console.log("this.policiesTabService.emitSensorsSubmittedEvent");
            this.policiesTabService.emitSensorsSubmittedEvent(this.trackedObjectId);
        }
    }

    onReset() {
        this.clearSensor(this.model.ShowCanBus, this.model.WireNumber, this.model.AnalogNumber, this.model.DigitNumber)
        this.model = new Sensor();
        this.submitted = false;
        this.EquationMax = false;
        this.getSensorDeviceConfiguration(this.trackedObjectId);
    }

    clearSensor(showCanbus, wire, analog, dig) {
        this.model = new Sensor();
        this.PortsList = [];
        this.model.ShowCanBus = showCanbus;
        this.model.DigitNumber = dig;
        this.model.AnalogNumber = analog;
        this.model.WireNumber = wire;
    }

    onMainSensorTypeChange(): void {
        // console.log("onMainSensorTypeChange");

        this.model.ShowEquationValue = false;
        this.model.X4Value = this.model.X3Value = this.model.X2Value = this.model.X1Value = this.model.ConstantValue = "0";
        this.submitted = false;
        this.FiltersensorTypeList = [];
        this.model.SensorTypeId = - 1;
        this.showDigital = false;
        this.model.SensorName = "";
        this.model.EventNameForOneDigit = "";
        this.model.EventNameForZeroDigit = "";
        this.model.IsCustom = false;
        this.PortsList = [];
        if (this.model.MainsensorTypeId != - 1) {
            this.FiltersensorTypeList = this.sensorTypeList.filter(s => s.ExtraFields.MainSensorTypeId == this.model.MainsensorTypeId);
            if (this.model.MainsensorTypeId == MainSensorType.digital)
                this.showDigital = true;
            else if (this.model.MainsensorTypeId == MainSensorType.analog)
                this.showDigital = false;

        }
        if (this.model.MainsensorTypeId != 1) {
            this.model.EventNameForZeroDigit = "";
            this.model.EventNameForOneDigit = "";
        }

        if (this.model.MainsensorTypeId == 1) {
            for (var i = 1; i <= this.model.AnalogNumber; i++) {
                //   if (!this.sensorList.Collection.some(x => x.PortNumber == i && x.MainSensorTypeId == this.model.MainsensorTypeId)) {
                this.PortsList.push({ Id: i, Name: 'A' + i });
                //  }
            }
        }
        if (this.model.MainsensorTypeId == 2) {
            for (var i = 1; i <= this.model.DigitNumber; i++) {
                //   if (!this.sensorList.Collection.some(x => x.PortNumber == i && x.MainSensorTypeId == this.model.MainsensorTypeId)) {
                this.PortsList.push({ Id: i, Name: 'D' + i });
                //   }
            }
        }
        if (this.model.MainsensorTypeId == 3) {
            for (var i = 1; i <= this.model.WireNumber; i++) {
                //   if (!this.sensorList.Collection.some(x => x.PortNumber == i && x.MainSensorTypeId == this.model.MainsensorTypeId)) {
                this.PortsList.push({ Id: i, Name: i + ' WD' });
                //    }
            }

        }

        // console.log("this.model", this.model);


    }
    onSensorTypeChange(): void {
        if (this.model.SensorTypeId != - 1) {
            if (this.model.SensorName == "" || this.model.SensorName == null)
                this.model.SensorName = this.getSensorType(this.model);

            if (this.getSensorType(this.model) == 'Custom') {
                this.model.IsCustom = true;
            }
            else {
                this.model.IsCustom = false;
            }
        }
        // if ibutton or rfid remove equation
        if (this.model.SensorTypeId == 8 || this.model.SensorTypeId == 9) {
            this.model.ShowEquationValue = false;
            this.model.X1Value = this.model.X2Value = this.model.X3Value = this.model.X4Value = "0";
        }

    }

    makeNullForSelect() {

        var sensorType = this.sensorTypeList.find(o => o.Id == this.model.SensorTypeId);
        if (sensorType != null && sensorType.ExtraFields.MainSensorTypeId == MainSensorType.digital) {
            this.model.SensorUnitId = null;
        }
        else if (sensorType != null && sensorType.ExtraFields.MainSensorTypeId == MainSensorType.analog) {
            this.model.DigitalValueId = null;
            this.model.DigitalValueNameId = null;
        }
    }

    makeDropDownSelected() {
        if (this.model.DigitalValueId == null)
            this.model.DigitalValueId = -1;
        if (this.model.DigitalValueNameId == null)
            this.model.DigitalValueNameId = -1;
        if (this.model.SensorUnitId == null)
            this.model.SensorUnitId = -1;
    }

    getSensorType(sensor: any): string {
        if (sensor["SensorNameExpression"] && sensor["SensorNameExpression"].includes("-Custom-")) {
            return sensor["SensorType"];
        }
        if (this.sensorTypeList.length > 0 && sensor.SensorTypeId != -1 && sensor.SensorTypeId != null) {
            var item = this.sensorTypeList.find(o => o.Id == sensor.SensorTypeId);
            return item && item.DisplayName;
        }
        else
            return this._localizer.transform("SensorDetails_NotFound");
    }

    getDigitalValue(digitalValueId: number): string {
        if (this.digitalValueList.length > 0 && digitalValueId != -1 && digitalValueId != null) {
            var item = this.digitalValueList.find(o => o.Id == digitalValueId);
            return item && item.DisplayName;
        }
        else
            return this._localizer.transform("SensorDetails_NotFound");
    }

    getDigitalValueName(digitalValueNameId: number): string {
        if (this.digitalValueNameList.length > 0 && digitalValueNameId != -1 && digitalValueNameId != null) {
            var item = this.digitalValueNameList.find(o => o.Id == digitalValueNameId);
            return item && item.DisplayName;
        }
        else
            return this._localizer.transform("SensorDetails_NotFound");
    }

    getUnit(unitId: number): string {
        if (this.sensorUnitList.length > 0 && unitId != -1 && unitId != null) {
            var item = this.sensorUnitList.find(o => o.Id == unitId);
            return item && item.DisplayName;
        }
        else
            return this._localizer.transform("SensorDetails_NotFound");
    }

    onSelected(item): void {
        item.isSelected = !item.isSelected;
        this.selectedSensor = this.sensorList.Collection.filter(o => o.isSelected).length;
        this.disableDeletedSelected = this.selectedSensor == 0;
        this.isSelectAll = this.sensorList.Collection.filter(o => o.isSelected).length == this.sensorList.Collection.length;
    }

    onSelectdAllInPage(): void {
        this.sensorList.Collection.forEach(c => { c.isSelected = this.isSelectAll; });
        this.selectedSensor = this.sensorList.Collection.filter(o => o.isSelected).length;
        this.disableDeletedSelected = this.sensorList.Collection.filter(o => o.isSelected).length == 0;
        this.isSelectAll = this.sensorList.Collection.filter(o => o.isSelected).length == this.sensorList.Collection.length;
    }

    onDeleteClickSelected() {

        this.sensorService.getRuleByVehicle(this.trackedObjectId).subscribe(res => {
            if (res.Value.length > 0) {
                if (this.checkRules(res.Value)) {
                    this._errorHandler.Handle(this._localizer.transform("SensorDetails_removeRules"));
                } else {
                    this.deleteMessage = this._localizer.transform("SensorDetails_DeleteAllMsg").replace('{0}', this.selectedSensor.toString());
                    this.messageDialog.show();
                }
            } else {
                this.deleteMessage = this._localizer.transform("SensorDetails_DeleteAllMsg").replace('{0}', this.selectedSensor.toString());
                this.messageDialog.show();
            }
        })
    }
    getSensorDeviceConfiguration(vehicleId) {
        this.sensorService.DeviceConfiguration(vehicleId).subscribe(result => {
            if (!result.IsErrorState && result.Value != null) {
                // console.log("getSensorDeviceConfiguration", 'result.Value', result.Value);
                let SensorData = result.Value;
                this.model.AnalogNumber = SensorData.AnalogInputs;
                this.model.DigitNumber = SensorData.DigitalInputs;
                this.model.WireNumber = SensorData.WireInputs;
            }
            this.deviceConfigurationData.emit(result.Value);

        });
    }

    checkRules(data): boolean {
        let selected = this.sensorList.Collection.filter(o => o.isSelected);
        let exists = false;
        selected.forEach(x => {

            if (data.some(d => d.ExpressionText.includes(x.SensorNameExpression))) {
                exists = true;
            }
        });
        return exists;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/sensorsTabForm/sensors-tab-form.component.ts